// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monad_lst_dashBoard_head {
    max-width: 1350px;
    margin: 0 auto;
    padding: 0px 20px 20px 20px;
    background-color: var(--card-background-color);
    font-family: var(--app-font-family);
}

.monad_lst_dashboard-title {
    color: var(--primary-color);
    text-align: center;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
}



.monad_lst_wallet_note {
    color: var(--text-color);
    font-weight: normal;
    font-size: 0.7rem;
}

.monad_lst_metrics_loader_card,
.monad_lst_metrics_error_card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    color: var(--text-color);
    background-color: var(--background-color);
}


.monad_lst_charts_container_1 {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0;
}

.monad_lst_chart_left_1,
.monad_lst_chart_right_1 {
    background: var(--card-background-color);
    border-radius: 8px;
    /* padding: 1rem; */
    width: 100%;
}

.monad_lst_charts_container_2 {
    display: grid;
    grid-template-columns: 60% 40%;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0;
}

.monad_lst_chart_left_2,
.monad_lst_chart_right_2 {
    background: var(--card-background-color);
    border-radius: 8px;
    /* padding: 1rem; */
    width: 100%;
}

.monad_lst_charts_container_3 {
    display: grid;
    grid-template-columns: 75% 25%;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0;
}

.monad_lst_chart_left_3,
.monad_lst_chart_right_3 {
    background: var(--card-background-color);
    border-radius: 8px;
    /* padding: 1rem; */
    width: 100%;
}

/* Common toggle container styles */
.monad_lst_common_toggle_container {
    display: flex;
    justify-content: center;
    margin: 15px 0;
    gap: 10px;
}

.monad_lst_toggle_button {
    background-color: white;
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    border-radius: 6px;
    padding: 8px 16px;
    font-family: var(--app-font-family);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.monad_lst_toggle_button:hover {
    background-color: rgba(0, 36, 117, 0.1);
}

.monad_lst_toggle_button.active {
    background-color: var(--primary-color);
    color: white;
}

/* Chart container for first component */
.monad_lst_dashboard_container {
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
    height: 480px;
    background-color: white;
}

.monad_lst_section_title {
    font-size: 16px;
    font-weight: normal;
    color: var(--text-color);
    text-align: center;
    padding: 10px 0;
}

.monad_lst_chart_section {
    padding: 0 15px 15px 15px;
}

.monad_lst_tooltip {
    background-color: white;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 8px 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.monad_lst_tooltip_date {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: var(--primary-color);
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 4px;
}

.monad_lst_tooltip_value {
    margin: 4px 0;
    font-size: 12px;
}

/* Provider timeseries chart styling */
.monad_provider_timeseries_container {
    display: flex;
    flex-direction: column;
    font-family: var(--app-font-family);
    color: var(--text-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
    height: 480px;
    background-color: white;
}

.monad_provider_chart_title {
    font-size: 16px;
    font-weight: normal;
    color: var(--text-color);
    text-align: center;
    padding: 10px 0 2px 0;
}

.monad_provider_chart_subtitle {
    font-size: 11px;
    color: var(--text-color);
    opacity: 0.7;
    text-align: center;
    padding: 0 0 5px 0;
}

.monad_provider_legend_container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid var(--border-color);
}

.monad_provider_select_all_button {
    padding: 4px 12px;
    cursor: pointer;
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 8px;
    font-weight: bold;
    font-family: var(--app-font-family);
}

.monad_provider_legend_item {
    display: flex;
    align-items: center;
    padding: 4px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid var(--border-color);
    transition: all 0.2s;
    font-weight: medium;
}

.monad_provider_legend_item.deselected {
    opacity: 0.5;
    background-color: #f5f5f5;
}

.monad_provider_legend_color_box {
    width: 12px;
    height: 12px;
    margin-right: 6px;
    border-radius: 2px;
}

.monad_provider_chart_container {
    padding: 15px;
    height: 330px;
    position: relative;
}

.monad_provider_tooltip_container {
    background-color: white;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.monad_provider_tooltip_title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: var(--primary-color);
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 4px;
}

.monad_provider_tooltip_item {
    margin: 4px 0;
    font-size: 12px;
}

/* Responsive design */
@media screen and (max-width: 768px) {
    .monad_provider_legend_container {
        padding: 8px 4px;
    }

    .monad_provider_legend_item {
        padding: 4px 8px;
        font-size: 10px;
    }

    .monad_lst_toggle_button {
        padding: 6px 12px;
        font-size: 12px;
    }
}

/* Responsive design for mobile devices */
@media screen and (max-width: 768px) {
    .monad_lst_charts_container_1 {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .monad_lst_chart_left_1,
    .monad_lst_chart_right_1 {
        width: 100%;
    }


    .monad_lst_charts_container_2 {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .monad_lst_chart_left_2,
    .monad_lst_chart_right_2 {
        width: 100%;
    }

    .monad_lst_charts_container_3 {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .monad_lst_chart_left_3,
    .monad_lst_chart_right_3 {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/monad_liquid_staking/monad_lst_dashboard.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2BAA2B;IAC3B,8CAA8C;IAC9C,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;;;AAIA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,yCAAyC;AAC7C;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA,wCAAwC;AACxC;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;;IAGA;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["@import \"./../../index.css\";\n\n.monad_lst_dashBoard_head {\n    max-width: 1350px;\n    margin: 0 auto;\n    padding: 0px 20px 20px 20px;\n    background-color: var(--card-background-color);\n    font-family: var(--app-font-family);\n}\n\n.monad_lst_dashboard-title {\n    color: var(--primary-color);\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 24px;\n    font-weight: bold;\n}\n\n\n\n.monad_lst_wallet_note {\n    color: var(--text-color);\n    font-weight: normal;\n    font-size: 0.7rem;\n}\n\n.monad_lst_metrics_loader_card,\n.monad_lst_metrics_error_card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    color: var(--text-color);\n    background-color: var(--background-color);\n}\n\n\n.monad_lst_charts_container_1 {\n    display: grid;\n    grid-template-columns: 50% 50%;\n    gap: 1rem;\n    width: 100%;\n    margin: 1rem 0;\n}\n\n.monad_lst_chart_left_1,\n.monad_lst_chart_right_1 {\n    background: var(--card-background-color);\n    border-radius: 8px;\n    /* padding: 1rem; */\n    width: 100%;\n}\n\n.monad_lst_charts_container_2 {\n    display: grid;\n    grid-template-columns: 60% 40%;\n    gap: 1rem;\n    width: 100%;\n    margin: 1rem 0;\n}\n\n.monad_lst_chart_left_2,\n.monad_lst_chart_right_2 {\n    background: var(--card-background-color);\n    border-radius: 8px;\n    /* padding: 1rem; */\n    width: 100%;\n}\n\n.monad_lst_charts_container_3 {\n    display: grid;\n    grid-template-columns: 75% 25%;\n    gap: 1rem;\n    width: 100%;\n    margin: 1rem 0;\n}\n\n.monad_lst_chart_left_3,\n.monad_lst_chart_right_3 {\n    background: var(--card-background-color);\n    border-radius: 8px;\n    /* padding: 1rem; */\n    width: 100%;\n}\n\n/* Common toggle container styles */\n.monad_lst_common_toggle_container {\n    display: flex;\n    justify-content: center;\n    margin: 15px 0;\n    gap: 10px;\n}\n\n.monad_lst_toggle_button {\n    background-color: white;\n    color: var(--primary-color);\n    border: 1px solid var(--primary-color);\n    border-radius: 6px;\n    padding: 8px 16px;\n    font-family: var(--app-font-family);\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.monad_lst_toggle_button:hover {\n    background-color: rgba(0, 36, 117, 0.1);\n}\n\n.monad_lst_toggle_button.active {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n/* Chart container for first component */\n.monad_lst_dashboard_container {\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    overflow: hidden;\n    height: 480px;\n    background-color: white;\n}\n\n.monad_lst_section_title {\n    font-size: 16px;\n    font-weight: normal;\n    color: var(--text-color);\n    text-align: center;\n    padding: 10px 0;\n}\n\n.monad_lst_chart_section {\n    padding: 0 15px 15px 15px;\n}\n\n.monad_lst_tooltip {\n    background-color: white;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    padding: 8px 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.monad_lst_tooltip_date {\n    margin: 0 0 8px 0;\n    font-weight: bold;\n    color: var(--primary-color);\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: 4px;\n}\n\n.monad_lst_tooltip_value {\n    margin: 4px 0;\n    font-size: 12px;\n}\n\n/* Provider timeseries chart styling */\n.monad_provider_timeseries_container {\n    display: flex;\n    flex-direction: column;\n    font-family: var(--app-font-family);\n    color: var(--text-color);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    overflow: hidden;\n    height: 480px;\n    background-color: white;\n}\n\n.monad_provider_chart_title {\n    font-size: 16px;\n    font-weight: normal;\n    color: var(--text-color);\n    text-align: center;\n    padding: 10px 0 2px 0;\n}\n\n.monad_provider_chart_subtitle {\n    font-size: 11px;\n    color: var(--text-color);\n    opacity: 0.7;\n    text-align: center;\n    padding: 0 0 5px 0;\n}\n\n.monad_provider_legend_container {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px 0;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.monad_provider_select_all_button {\n    padding: 4px 12px;\n    cursor: pointer;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-right: 8px;\n    font-weight: bold;\n    font-family: var(--app-font-family);\n}\n\n.monad_provider_legend_item {\n    display: flex;\n    align-items: center;\n    padding: 4px 12px;\n    cursor: pointer;\n    border-radius: 4px;\n    font-size: 12px;\n    border: 1px solid var(--border-color);\n    transition: all 0.2s;\n    font-weight: medium;\n}\n\n.monad_provider_legend_item.deselected {\n    opacity: 0.5;\n    background-color: #f5f5f5;\n}\n\n.monad_provider_legend_color_box {\n    width: 12px;\n    height: 12px;\n    margin-right: 6px;\n    border-radius: 2px;\n}\n\n.monad_provider_chart_container {\n    padding: 15px;\n    height: 330px;\n    position: relative;\n}\n\n.monad_provider_tooltip_container {\n    background-color: white;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    padding: 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.monad_provider_tooltip_title {\n    margin: 0 0 8px 0;\n    font-weight: bold;\n    color: var(--primary-color);\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: 4px;\n}\n\n.monad_provider_tooltip_item {\n    margin: 4px 0;\n    font-size: 12px;\n}\n\n/* Responsive design */\n@media screen and (max-width: 768px) {\n    .monad_provider_legend_container {\n        padding: 8px 4px;\n    }\n\n    .monad_provider_legend_item {\n        padding: 4px 8px;\n        font-size: 10px;\n    }\n\n    .monad_lst_toggle_button {\n        padding: 6px 12px;\n        font-size: 12px;\n    }\n}\n\n/* Responsive design for mobile devices */\n@media screen and (max-width: 768px) {\n    .monad_lst_charts_container_1 {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n    }\n\n    .monad_lst_chart_left_1,\n    .monad_lst_chart_right_1 {\n        width: 100%;\n    }\n\n\n    .monad_lst_charts_container_2 {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n    }\n\n    .monad_lst_chart_left_2,\n    .monad_lst_chart_right_2 {\n        width: 100%;\n    }\n\n    .monad_lst_charts_container_3 {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n    }\n\n    .monad_lst_chart_left_3,\n    .monad_lst_chart_right_3 {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
